import sidebar from '@/config/sidebars/adminHubspot'
import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminHubspotCompanies = {
  index: async(props) => {
    const { default: CompaniesIndex } = await import('@/vue_widgets/admin/hubspot/companies/index.vue')
    createVueApp(CompaniesIndex, { props, sidebar })
  },
  show: async(props) => {
    const { default: CompaniesShow } = await import('@/vue_widgets/admin/hubspot/companies/show.vue')
    createVueApp(CompaniesShow, { props, sidebar })
  }
}
